export default function validateEmailDomain() {
  return (key, newValue /*, oldValue, changes, content*/) => {
    if (newValue == null || newValue.indexOf('@') === -1) {
      return true;
    }

    let emailDomain = newValue.split('@')[1].toLowerCase();
    if (emailDomain.indexOf('donorelf') >= 0) {
      return "Email domain cannot contain 'donorelf'";
    }
    return true;
  };
}
